function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var msToNumber = function msToNumber(ms) {
  return parseInt(ms.slice(0, -2));
};
export var makeTooltipStyles = function makeTooltipStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  var _primitives$transitio = primitives.transitions,
    duration = _primitives$transitio.duration,
    easing = _primitives$transitio.easing;
  return {
    MuiTooltip: {
      defaultProps: {
        TransitionProps: {
          timeout: {
            enter: msToNumber(duration[1]),
            exit: msToNumber(duration[4])
          },
          easing: {
            enter: easing["slow-down"],
            exit: easing["speed-up"]
          }
        }
      },
      styleOverrides: {
        popper: {
          '& [class*="MuiTooltip-arrow"]': {
            fontSize: primitives.spacings[2],
            "&::before": {
              backgroundColor: tokens.colors["detail-2-opaque"]
            }
          },
          '& [class*="MuiTooltip-tooltip"]': _objectSpread({
            backgroundColor: tokens.colors["detail-2-opaque"],
            padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
            color: tokens.colors["ink-on-fill-primary"],
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            borderRadius: primitives.borderRadii.small,
            '& [class*="MuiTypography-root"]': {
              color: tokens.colors["ink-on-fill-primary"]
            },
            ".MuiDivider-root": {
              marginTop: primitives.spacings["2"],
              marginBottom: primitives.spacings["2"]
            }
          }, tokens.typography.smallprint)
        }
      }
    }
  };
};